// Detects "the browser couldn't load a piece of the app's code" failures.
// These happen when a phone still holds an older page while the app's code
// files have been rebuilt (dev server restart, new deploy). Safari reports
// them as "Importing a module script failed."; retrying in-place can never
// succeed because the old file addresses are gone — only a fresh page load can.

const PATTERNS = [
  /Importing a module script failed/i,
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /Unable to preload CSS/i,
  /Loading (CSS )?chunk [\w-]+ failed/i,
  /'text\/html' is not a valid JavaScript MIME type/i,
];

export function isChunkLoadError(error: unknown): boolean {
  const msg =
    error instanceof Error
      ? `${error.name}: ${error.message}`
      : typeof error === "string"
        ? error
        : "";
  return PATTERNS.some((re) => re.test(msg));
}

const KEY = "bidnova:chunk-reload-at";
const WINDOW_MS = 30_000;

/**
 * Reload the page once to pick up fresh code. Guarded so a genuinely broken
 * file can't cause a reload loop: at most one automatic reload per 30s.
 * Returns true when a reload was started.
 */
export function reloadOnceForChunkError(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const last = Number(sessionStorage.getItem(KEY) || 0);
    if (Date.now() - last < WINDOW_MS) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    /* storage blocked — still allow a single reload */
  }
  window.location.reload();
  return true;
}
